import { initValidateShiftTimes } from './shiftTimes'
import { initValidateTemperature } from './temperature'
import { initValidateWorkers } from './workers-and-mechanization'
import { initValidateWeather } from './weather'
import { initValidateSign, isEditedBySupervisor } from './signValidation'
import { initValidateWorkDescription } from './work-description'
import { initValidateRemarks } from './remarks'
import { initValidateNavigation } from './navigation'

export function initValidate () {
  if (isEditedBySupervisor()) {
    initValidateRemarks()
    initValidateSign()
  } else {
    initValidateShiftTimes()
    initValidateWorkers()
    initValidateTemperature()
    initValidateWeather()
    initValidateWorkDescription()
    initValidateSign()
  }
  initValidateNavigation()
}